import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/snapchat-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM393.5 346.9C390 355 375.4 360.9 348.7 365.1 347.3 367 346.2 374.9 344.4 381 343.3 384.7 340.7 386.9 336.3 386.9H336.1C329.9 386.9 323.3 384 310.3 384 292.7 384 286.6 388 272.9 397.7 258.4 408 244.5 416.8 223.7 415.9 202.7 417.5 185.1 404.7 175.2 397.7 161.4 388 155.4 384 137.8 384 125.3 384 117.4 387.1 112 387.1 106.6 387.1 104.5 383.8 103.7 381.1 101.9 375 100.8 367 99.4 365.1 85.6 363 54.6 357.6 53.9 343.7 53.7 340.1 56.2 336.9 59.8 336.3 106.1 328.7 126.9 281.2 127.8 279.2 127.8 279.1 127.9 279 128 278.9 130.5 273.9 131 269.7 129.6 266.4 126.2 258.5 111.7 255.7 105.6 253.2 89.8 247 87.6 239.8 88.6 234.9 90.2 226.4 103 221.1 110.5 224.6 116.4 227.4 121.7 228.8 126.2 228.8 129.5 228.8 131.7 228 132.8 227.4 131.4 203.5 128.1 169.4 136.6 150.3 159.1 100 206.7 96 220.7 96 221.3 96 226.8 95.9 227.4 95.9 262.1 95.9 295.4 113.7 311.7 150.2 320.2 169.3 316.9 203.3 315.5 227.3 316.6 227.9 318.4 228.6 321.2 228.7 325.5 228.5 330.4 227.1 335.9 224.5 339.9 222.6 345.5 222.9 349.5 224.5 355.8 226.8 359.8 231.3 359.9 236.4 360 242.9 354.2 248.5 342.7 253 341.3 253.6 339.6 254.1 337.8 254.7 331.3 256.8 321.4 259.9 318.8 266.2 317.4 269.5 318 273.7 320.4 278.7 320.5 278.8 320.5 278.9 320.6 279 321.5 281 342.3 328.5 388.6 336.1 392.6 337.1 395.7 341.6 393.5 346.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/snapchat-square.js
// module id = N1pt
// module chunks = 144